import React from 'react';
import { Container} from '@material-ui/core';
import Navbar from './components/Navbar/Navbar';
import Home from './components/Home/Home';
import PostDetails from './components/PostDetails/PostDetails';
import { BrowserRouter,Route,Routes,Navigate} from 'react-router-dom';
import Auth from './components/Auth/Auth';
import { GoogleOAuthProvider } from '@react-oauth/google';


const App = () => {
  const user = JSON.parse(localStorage.getItem('profile'));

  return (
    <GoogleOAuthProvider clientId="953249247729-ijrv49u5msic8idripjoo16s3qc4q5em.apps.googleusercontent.com">
      <BrowserRouter>
        <Container maxWidth="xl">
        <Navbar />
        <Routes>
            <Route path="/" element={<Navigate replace to="/posts" />} />
            <Route path="/posts" exact element={<Home />}/>
            <Route path="/posts/search" exact element={<Home />}/>
            <Route path="/posts/:id" element={<PostDetails />}/>
            <Route path="/auth" exact element={!user ? <Auth /> : <Navigate replace to="/posts" />}/>
        </Routes>
        </Container>
      </BrowserRouter>
  </GoogleOAuthProvider>
  );
};

export default App;